/**
 * Ethiopian birr.
 */
export var ETB = {
  code: 'ETB',
  base: 10,
  exponent: 2
};